import { render, staticRenderFns } from "./form-create-info.vue?vue&type=template&id=93920a9e&scoped=true"
import script from "./form-create-info.vue?vue&type=script&setup=true&lang=js"
export * from "./form-create-info.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93920a9e",
  null
  
)

export default component.exports